import {RttrAction} from "./rttrReducer";
import {IAction} from "../IAction";

export interface RealmHandoffPayload {
    realmUuid: string;
    realmTs?: string;
    realmSig?: string;
    /*
     * Realm-provided Home URL captured from the `?realm_home=...` query
     * param on the initial WebFrame load. The MinelabRttrBottomNav Home
     * button uses this to navigate the WebView back to Realm's home page
     * on tap. Per-environment (dev vs prod) because Realm hosts dev at
     * mipl-dev.outsystemsenterprise.com and prod at a different domain.
     */
    realmHomeUrl?: string;
}

export function setRealmHandoff(payload: RealmHandoffPayload): IAction<RttrAction.SET_REALM_HANDOFF, RealmHandoffPayload> {
    return {
        type: RttrAction.SET_REALM_HANDOFF,
        payload,
    };
}

export function clearRealmHandoff(): IAction<RttrAction.CLEAR_REALM_HANDOFF, null> {
    return {
        type: RttrAction.CLEAR_REALM_HANDOFF,
    };
}
